export default __webpack_public_path__ + "static/media/getstarted.b397e800.png";